import * as React from 'react'
import * as classNames from 'classnames'

import * as Style from './style.css'

type IPageType =
  | typeof PAGE_TYPE_PROFILE
  | typeof PAGE_TYPE_DASHBOARD
  | typeof PAGE_TYPE_CONTACT
  | typeof PAGE_TYPE_RESERVE
  | typeof PAGE_TYPE_JOBPOST
  | typeof PAGE_TYPE_FAVORITE
  | typeof PAGE_TYPE_MATCHING
  | typeof PAGE_TYPE_POINT
  | typeof PAGE_TYPE_ALBUM
  | typeof PAGE_TYPE_PAYMENT
  | typeof PAGE_TYPE_TRIAL_SEARCH_SITTER
  | typeof PAGE_TYPE_TRIAL_SEARCH_HOUSEKEEPER

export interface IProps {
  user: IUser
  pageType?: IPageType
}

export const PAGE_TYPE_PROFILE = 'PROFILE'
export const PAGE_TYPE_DASHBOARD = 'DASHBOARD'
export const PAGE_TYPE_CONTACT = 'CONTACT'
export const PAGE_TYPE_RESERVE = 'RESERVE'
export const PAGE_TYPE_JOBPOST = 'JOBPOST'
export const PAGE_TYPE_FAVORITE = 'FAVORITE'
export const PAGE_TYPE_MATCHING = 'MATCHING'
export const PAGE_TYPE_POINT = 'POINT'
export const PAGE_TYPE_ALBUM = 'ALBUM'
export const PAGE_TYPE_PAYMENT = 'PAYMENT'
export const PAGE_TYPE_TRIAL_SEARCH_SITTER = 'TRIAL_SEARCH_SITTER'
export const PAGE_TYPE_TRIAL_SEARCH_HOUSEKEEPER = 'TRIAL_SEARCH_HOUSEKEEPER'

const makeUserNavs = (user: IUser, pageType?: IPageType) => {
  const navs = [
    {
      label: 'ご利用申請',
      href: '/users/base',
      visible: user.apply_status === 'unapplied',
      active: pageType === PAGE_TYPE_PROFILE,
    },
    {
      label: 'お知らせ',
      href: '/users/dashboard',
      visible: true,
      active: pageType === PAGE_TYPE_DASHBOARD,
    },
    {
      label: 'メッセージ',
      href: '/contacts',
      visible: true,
      active: pageType === PAGE_TYPE_CONTACT,
    },
    {
      label: '予約一覧',
      href: '/reserves',
      visible: true,
      active: pageType === PAGE_TYPE_RESERVE,
    },
    {
      label: 'サポーター募集',
      href: '/jobposts',
      visible: true,
      active: pageType === PAGE_TYPE_JOBPOST,
    },
    {
      label: 'お気に入り',
      href: '/users/favorite_sitter',
      visible: true,
      active: pageType === PAGE_TYPE_FAVORITE,
    },
    {
      label: '過去に依頼したサポーター',
      href: '/users/matching_sitter',
      visible: true,
      active: pageType === PAGE_TYPE_MATCHING,
    },
    {
      label: 'プロフィール編集',
      href: '/users/base',
      visible: user.apply_status === 'applied',
      active: pageType === PAGE_TYPE_PROFILE,
    },
    {
      label: 'マイポイント',
      href: '/points',
      visible: true,
      active: pageType === PAGE_TYPE_POINT,
    },
    {
      label: 'アルバム',
      href: '/sitting_photo_albums',
      visible: user.children.length > 0,
      active: pageType === PAGE_TYPE_ALBUM,
    },
    {
      label: '設定',
      href: '/users/account_payment',
      visible: true,
      active: pageType === PAGE_TYPE_PAYMENT,
    },
    {
      label: 'サポートモニタリング',
      href: '/trial_search_sitter',
      visible: user.show_trial_search && user.trial_sitter,
      active: pageType === PAGE_TYPE_TRIAL_SEARCH_SITTER,
    },
    {
      label: '家事サポート実習',
      href: '/trial_search',
      visible: user.show_trial_search && user.trial_housekeeping,
      active: pageType === PAGE_TYPE_TRIAL_SEARCH_HOUSEKEEPER,
    },
  ]
  return navs.filter((nav) => nav.visible)
}

export const ParentUserNav = ({ user, pageType }: IProps): JSX.Element => {
  const navs = makeUserNavs(user, pageType)

  return (
    <ul className={Style.ParentUserNav}>
      {navs.map((nav) => (
        <li className={Style.ParentUserNavItem} key={`usernav-${nav.label}`}>
          <a
            href={nav.href}
            className={classNames({
              [Style.ParentUserNavItemText]: true,
              [Style.ParentUserNavItemTextActive]: nav.active,
            })}
          >
            {nav.label}
          </a>
        </li>
      ))}
    </ul>
  )
}
